import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navClass = ({ isActive }) =>
  `text-sm font-medium transition-colors ${
    isActive ? 'text-primary-700' : 'text-slate-600 hover:text-slate-900'
  }`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 4);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-shadow ${
        isScrolled
          ? 'border-b border-slate-200/80 bg-white/95 shadow-soft backdrop-blur-md'
          : 'border-b border-transparent bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="container-custom">
        <div className="flex h-20 items-center justify-between gap-4">
          <Link
            to="/"
            aria-label="Drivor home"
            className="shrink-0"
          >
            <img src="/brand/logo-primary.svg" alt="Drivor" className="h-[70px] w-auto" />
          </Link>

          <nav className="hidden items-center gap-6 md:flex" aria-label="Primary">
            <NavLink to="/how-it-works" className={navClass}>
              How it works
            </NavLink>
            <NavLink to="/demo" className={navClass}>Demo</NavLink>
            <NavLink to="/contact" className={navClass}>Contact</NavLink>
            <a
              href="https://app.drivor.in/login"
              rel="noopener noreferrer"
              className="btn-secondary py-2.5 text-sm"
            >
              Login
            </a>
            <a
              href="https://app.drivor.in/signup"
              rel="noopener noreferrer"
              className="btn-primary py-2.5 text-sm"
            >
              Start booking
            </a>
          </nav>

          <button
            type="button"
            className="rounded-md p-2 text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-primary-500 md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen}
            aria-controls="mobile-nav"
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            id="mobile-nav"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="border-t border-slate-200 bg-white md:hidden"
          >
            <div className="container-custom flex flex-col gap-1 py-4">
              <NavLink
                to="/how-it-works"
                onClick={() => setIsOpen(false)}
                className="py-3 text-base font-medium text-slate-800"
              >
                How it works
              </NavLink>
              <NavLink
                to="/demo"
                onClick={() => setIsOpen(false)}
                className="py-3 text-base font-medium text-slate-800"
              >
                Demo
              </NavLink>
              <NavLink
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="py-3 text-base font-medium text-slate-800"
              >
                Contact
              </NavLink>
              <a
                href="https://app.drivor.in/login"
                rel="noopener noreferrer"
                className="py-3 text-base font-medium text-slate-800"
              >
                Login
              </a>
              <a
                href="https://app.drivor.in/signup"
                rel="noopener noreferrer"
                className="btn-primary mt-2 w-full text-center"
              >
                Start booking
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
